<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="homebox">
      <div class="racetitle">
        <img src="~assets/images/race/raceitem2.jpg" alt="" />
        <div class="racemask"></div>
        <p>{{ racedes.raceName }}</p>
      </div>

      <div class="racetype">
        <div class="typebg">
          <img src="~assets/images/race/typebg.jpg" alt="" />
          <p class="type1box">
            {{ racedes.countryName }}-{{ racedes.cityName }}
          </p>
          <p class="type2box">{{ racedes.racetime }}</p>
          <p class="type3box">{{ racedes.racePeopleNumber }}</p>
          <p class="type4box">{{ racedes.days }}</p>
        </div>
      </div>

      <div class="topdes">
        <div class="leftdes">
          <p class="leftdes-title">{{ racedes.raceName }}</p>
          <p class="leftdes-content" v-html="racedes.raceContent"></p>
          <div class="leftdes-img">
            <img :src="racedes.raceImage" alt="" />
          </div>
        </div>

        <div class="rightdes">
          <div class="bigregbox" v-show="!showregbox">
            <div class="regbox1">
              <p class="regbox-title">姓名</p>
              <input
                type="text"
                placeholder="中文姓名"
                class="regbox-input"
                v-model="formData.userFullName"
              />
              <input
                type="text"
                placeholder="姓名拼音"
                class="regbox-input2"
                v-model="formData.englishName"
              />
            </div>

            <div class="regbox2">
              <p class="regbox-title">邮箱</p>
              <input
                type="text"
                placeholder="输入您的电子邮箱"
                class="regbox-inputall"
                v-model="formData.userEmail"
              />
            </div>
            <div class="regbox3">
              <p class="regbox-title">手机号码</p>
              <input
                type="text"
                placeholder="输入您的手机号码"
                class="regbox-inputall"
                v-model="formData.userPhone"
              />
            </div>
            <div class="regbox5">
              <button class="regbox-button" @click="handleregbtn">提交</button>
            </div>
          </div>

          <div class="bigregbox2" v-show="showregbox">
            <div class="packbox">
              <p class="packbox-title">套餐选择</p>
              <div class="packlist">
                <select
                  id="my-select"
                  v-model="selectedOption"
                  @change="onSelectChange"
                  class="regbox-select"
                >
                  <option
                    v-for="option in racedes.packageList"
                    :key="option.id"
                    :value="option.id"
                  >
                    {{ option.packageName }}
                  </option>
                </select>
              </div>
              <div class="packdesbox" v-html="packdes"></div>
              <div class="packpricebox">￥{{ packprice }}</div>
              <div class="buypackbtn" @click="handlebuybtn">
                <a href="#">购买此套餐</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="middes">
        <div  class="racetype1box" v-show="showracebox1tripPlan"   :style="showtype1 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype1">
            <a href="javascript:void(0)" @click="ChageceType1">
              <p>{{racedes.key1}}</p>
              <!-- <img src="~assets/images/race/racetype1.jpg" alt="" />-->
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype1">
            <a href="javascript:void(0)" @click="ChageceType1">
               <p>{{racedes.key1}}</p>
              <!-- <img src="~assets/images/race/racetypeon1.jpg" alt="" />-->
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype1"
            class="racetype1content"
            v-html="racedes.value1"
          ></div>
        </div>

        <div  class="racetype1box" v-show="showracebox2packageIntroduction"   :style="showtype2 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype2">
            <a href="javascript:void(0)" @click="ChageceType2">
              <p>{{racedes.key2}}</p>
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype2">
            <a href="javascript:void(0)" @click="ChageceType2">
               <p>{{racedes.key2}}</p>
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype2"
            class="racetype1content"
            v-html="racedes.value2"
          ></div>
        </div>

        <div  class="racetype1box" v-show="showracebox3packageContent"   :style="showtype3 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype3">
            <a href="javascript:void(0)" @click="ChageceType3">
              <p>{{racedes.key3}}</p>
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype3">
            <a href="javascript:void(0)" @click="ChageceType3">
               <p>{{racedes.key3}}</p>
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype3"
            class="racetype1content"
            v-html="racedes.value3"
          ></div>
        </div>

        <div  class="racetype1box" v-show="showracebox4priceDetails"   :style="showtype4 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype4">
            <a href="javascript:void(0)" @click="ChageceType4">
              <p>{{racedes.key4}}</p>
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype4">
            <a href="javascript:void(0)" @click="ChageceType4">
               <p>{{racedes.key4}}</p>
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype4"
            class="racetype1content"
            v-html="racedes.value4"
          ></div>
        </div>

        <div  class="racetype1box" v-show="showracebox5accommodateDetails"   :style="showtype5 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype5">
            <a href="javascript:void(0)" @click="ChageceType5">
              <p>{{racedes.key5}}</p>
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype5">
            <a href="javascript:void(0)" @click="ChageceType5">
               <p>{{racedes.key5}}</p>
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype5"
            class="racetype1content"
            v-html="racedes.value5"
          ></div>
        </div>


        <div  class="racetype1box" v-show="showracebox6publicTransportation"   :style="showtype6 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype6">
            <a href="javascript:void(0)" @click="ChageceType6">
              <p>公共交通</p>
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype6">
            <a href="javascript:void(0)" @click="ChageceType6">
               <p>公共交通</p>
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype6"
            class="racetype1content"
            v-html="racedes.publicTransportation"
          ></div>
        </div>

        <!-- <div  class="racetype1box" v-show="showracebox7raceTransportation"   :style="showtype7 ? { border: '1px solid #4a3aff' } : {}">
          <div class="racetype1image" v-show="!showtype7">
            <a href="javascript:void(0)" @click="ChageceType7">
              <p>比赛交通</p>
            </a>
            <div
              style="background-color: rgb(255, 255, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(74, 58, 255)"
                ></div>
              </div>
            </div>
          </div>
          <div class="racetype1image" v-show="showtype7">
            <a href="javascript:void(0)" @click="ChageceType7">
               <p>比赛交通</p>
            </a>
            <div
              style="background-color: rgb(74, 58, 255)"
              class="racetypearrow"
            >
              <div
                style=""
                class="accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"
              >
                <div
                  class="arrow-line---brix _2---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
                <div
                  class="arrow-line---brix _1---brix"
                  style="background-color: rgb(255, 255, 255)"
                ></div>
              </div>
            </div>
          </div>

          <div
            v-show="showtype7"
            class="racetype1content"
            v-html="racedes.raceTransportation"
          ></div>
        </div> -->




      </div>
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios

export default {
  name: "racedes",
  data() {
    return {
      showregbox: true,
      showtype1: false,
      showtype2: false,
      showtype3: false,
      showtype4: false,
      showtype5: false,
      showtype6: false,
      showtype7: false,
      raceid: 0,
      racedes: {},
      selectedOption: "", // 当前选中的值
      packdes: "",
      packprice: "",

      formData: {
        userFullName: "", // 用户名（手机号或邮箱）
        englishName: "", // 用户名（手机号或邮箱）
        userEmail: "", // 用户名（手机号或邮箱）
        userPhone: "", // 用户名（手机号或邮箱）
      },
      raceList: [],
      showracebox1tripPlan:true,
      showracebox2packageIntroduction:false,
      showracebox3packageContent:false,
      showracebox4priceDetails:false,
      showracebox5accommodateDetails:false,
      showracebox6publicTransportation:false,
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Home",
      });
    },
    ChageceType1: function () {
      this.showtype1 = !this.showtype1;
    },
    ChageceType2: function () {
      this.showtype2 = !this.showtype2;
    },
    ChageceType3: function () {
      this.showtype3 = !this.showtype3;
    },
    ChageceType4: function () {
      this.showtype4 = !this.showtype4;
    },
    ChageceType5: function () {
      this.showtype5 = !this.showtype5;
    },
    ChageceType6: function () {
      this.showtype6 = !this.showtype6;
    },    
    ChageceType7: function () {
      this.showtype7 = !this.showtype7;
    },

    handleregbtn: function () {
      console.log("handleregbtn");
      this.sendloginPostRequest();
    },
    handlebuybtn: function () {
      console.log("handlebuybtn");
    },

    onSelectChange() {
      console.log("你选择了：", this.selectedOption);
      const packageItem = this.racedes.packageList.find(
        (item) => item.id === this.selectedOption
      );

      this.packdes = packageItem.packageContent;
      this.packprice = packageItem.packagePrice;
    },

    async sendloginPostRequest() {
      try {
        // if (this.isButton1Disabled) return;
        // // 禁用按钮
        // this.isButton1Disabled = true;
        // // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        if (
          !this.formData.userFullName ||
          !this.formData.englishName ||
          !this.formData.userEmail ||
          !this.formData.userPhone
        ) {
          this.error = "";
          return;
        }
        this.formData.raceId = this.raceid;

        // 配置 POST 请求的 URL 和数据
        const url =
          "https://ttserver.aizhuotice.online/api/v1/save/ttMessageBoard";
        console.log(this.formData);
        // 发起 POST 请求
        const response = await axios.post(url, this.formData, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          alert("提交成功");
         
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      } finally {
        // 无论成功或失败，都重新启用按钮
        this.isButton1Disabled = false;
      }
    },
    async GetRaceDes() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          id: this.raceid,
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/ttRaceInfo";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.racedes = this.response.data;
          // console.log(this.racedes);
          const isoDateString = this.racedes.raceDate.replace(" ", "T");
          const dateObject = new Date(isoDateString);
          // console.log(dateObject.getMonth());
          this.racedes.racetime =
            dateObject.getFullYear() +
            "年" +
            (dateObject.getMonth() + 1) +
            "月" +
            dateObject.getDate() +
            "日";
          const packageItem = this.racedes.packageList[0];

         
          if (this.racedes.value1.length<30) {
            this.showracebox1tripPlan = false;
          }else{
            this.showracebox1tripPlan = true;
          }

          if (this.racedes.value2.length<30) {
            this.showracebox2packageIntroduction = false;
          }else{
            this.showracebox2packageIntroduction = true;
          }

          console.log(this.racedes.value3.length);
          if (this.racedes.value3.length<30) {
            this.showracebox3packageContent = false;
          }else{
            this.showracebox3packageContent = true;
          }
          if (this.racedes.value4.length<30) {
            this.showracebox4priceDetails = false;
          }else{
            this.showracebox4priceDetails = true;
          }

          if (this.racedes.value5.length<30) {
            this.showracebox5accommodateDetails = false;
          }else{
            this.showracebox5accommodateDetails = true;
          }

          // if (this.racedes.publicTransportation.length<30) {
          //   this.showracebox6publicTransportation = false;
          // }else{
          //   this.showracebox6publicTransportation = true;
          // }

            this.racedes.raceImage = "~assets/images/race/raceitem2.jpg";
            this.racedes.imageList.forEach((element3) => {
              this.racedes.raceImage = element3.imageUrl;
            });

             this.packdes = packageItem.packageContent;
          this.packprice = packageItem.packagePrice;
          this.selectedOption = packageItem.id;


        } else {
          console.log(this.response.code);
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },

    async GetRaceList() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 10,
        };

        const url =
          "https://ttserver.aizhuotice.online/api/v1/ttRaceInfoDetails/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.raceList = this.response.data.data;
          // console.log("this.raceList");
          // console.log(this.raceList);
          // console.log(this.raceList.length);
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    this.raceid = this.$route.params.id;
    // console.log(this.$route.params);
    console.log(this.raceid);
    if (this.raceid == null) {
      this.raceid = 1;
    }
    // console.log(this.raceid);
    this.GetRaceDes();
    this.GetRaceList();
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.homebox {
  width: 100vw;
  height: auto;
  position: relative;
}
.racetitle {
  position: relative;
  width: 100vw;
  height: 30vw;
  background-color: #fff;
  overflow: hidden; /* 超出部分隐藏 */
}
.racetitle img {
  width: 100%; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
}
.racetitle p {
  position: absolute;
  top: 20vw;
  left: 3vw;
  width: 100%;
  height: 100%;
  font-size: 5vw;
  font-weight: bold;
  color: #fff;
}
.racemask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 30vw;
  background-color: rgba(0, 0, 0, 0.3);
}

.racetype {
  position: relative;
  width: 100vw;
  height: 19vw;
}
.typebg {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.typebg img {
  width: 100%;
  height: 100%;
}
.type1box {
  position: absolute;
  top: 15vw;
  left: 5vw;
  width: 20vw;
  height: 2vw;
  font-size: 2vw;
  color: #000;
  text-align: center;
}
.type2box {
  position: absolute;
  top: 15vw;
  left: 28vw;
  width: 20vw;
  height: 2vw;
  font-size: 2vw;
  color: #000;
  text-align: center;
}
.type3box {
  position: absolute;
  top: 15vw;
  left: 52vw;
  width: 20vw;
  height: 2vw;
  font-size: 2vw;
  color: #000;
  text-align: center;
}
.type4box {
  position: absolute;
  top: 15vw;
  left: 75vw;
  width: 20vw;
  height: 2vw;
  font-size: 2vw;
  color: #000;
  text-align: center;
}
.topdes {
  position: relative;
  width: 100vw;
  height: auto;
  /* background-color: #eee; */
}
.topdes h2 {
  font-size: 1.5vw;
}

.leftdes {
  position: relative;
  top: 0;
  left: 5vw;
  width: 45vw;
  height: auto;
}

.leftdes-title {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 5vw;
  font-size: 3vw;
  font-weight: bold;
  color: #000;
}
.leftdes-content {
  position: relative;
  top: 1vw;
  left: 0;
  width: 100%;
  height: auto;
  font-size: 1.3vw;
  color: #000;
  overflow: hidden; /* 超出部分隐藏 */
}

.leftdes-img {
  position: relative;
  width: 45vw;
  height: 25vw;
  top: 2vw;
  left: 0;
  background-color: #fff;
  overflow: hidden; /* 超出部分隐藏 */
  margin-bottom: 8vw;
}

.leftdes-img img {
  width: 100%; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
}

.rightdes {
  position: absolute;
  top: 0;
  right: 0;
  width: 50vw;
  height: 100%;
}
.bigregbox {
  position: absolute;
  top: 0;
  left: 12vw;
  width: 30vw;
  height: 35vw;
  background-color: #b5b5b5;
  border-radius: 1vw;
}
.regbox1 {
  position: absolute;
  top: 3vw;
  left: 5vw;
  width: 25vw;
  height: 4vw;
}
.regbox-title {
  position: absolute;
  width: 100%;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.3vw;
  color: #fff;
}
.regbox-input {
  position: absolute;
  top: 2vw;
  left: 0;
  width: 10vw;
  height: 1.9vw;
  font-size: 1.2vw;
  border: 1px solid #ccc;
  border-radius: 0.3vw;
  padding-left: 0.1vw;
  text-align: left;
}
.regbox-input2 {
  position: absolute;
  top: 2vw;
  left: 12vw;
  width: 10vw;
  height: 1.9vw;
  font-size: 1.2vw;
  border: 1px solid #ccc;
  border-radius: 0.3vw;
  padding-left: 0.1vw;
  text-align: left;
}
.regbox2 {
  position: absolute;
  top: 8vw;
  left: 5vw;
  width: 25vw;
  height: 4vw;
}

.regbox-inputall {
  position: absolute;
  top: 2vw;
  left: 0;
  width: 22vw;
  height: 1.9vw;
  font-size: 1.2vw;
  border: 1px solid #ccc;
  border-radius: 0.3vw;
  padding-left: 0.1vw;
  text-align: left;
}
.regbox3 {
  position: absolute;
  top: 13vw;
  left: 5vw;
  width: 25vw;
  height: 4vw;
}
.regbox4 {
  position: absolute;
  top: 18vw;
  left: 5vw;
  width: 25vw;
  height: 4vw;
}

.regbox5 {
  position: absolute;
  top: 23vw;
  left: 5vw;
  width: 25vw;
  height: 4vw;
}
.regbox-button {
  position: relative;
  top: 3vw;
  left: 0vw;
  width: 22vw;
  height: 3vw;
  background-color: #a81f24;
  border-radius: 0.3vw;
  font-size: 1.2vw;
  color: #fff;
  text-align: center;
  border: 0px solid #ccc;
}

.bigregbox2 {
  position: absolute;
  top: 4vw;
  left: 2vw;
  width: 40vw;
  height: 35vw;
  /* background-color: #eee; */
  border-radius: 1vw;
}

.packbox {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.packbox-title {
  position: relative;
  top: 1.5vw;
  left: 1vw;
  width: 100%;
  height: 3vw;
  font-size: 1.2vw;
  font-weight: bold;
}
.packlist {
  position: absolute;
  top: 0.7vw;
  left: 7vw;
  width: 30vw;
  height: 3vw;
}

.regbox-select {
  position: absolute;
  top: 0vw;
  left: 0;
  width: 30vw;
  height: 3vw;
  font-size: 1.2vw;
  border: 1px solid #ccc;
  /* border-radius: 0.3vw; */
  padding-left: 0.1vw;
  text-align: left;
  background-color: #686868;
  line-height: 3vw;
  color: #fff;
}

.packdesbox {
  position: relative;
  top: 2vw;
  left: 7vw;
  width: 30vw;
  height: auto;
  font-size: 1.1vw;
  color: #000;
}
.packpricebox {
  position: relative;
  top: 6vw;
  left: 7vw;
  width: 30vw;
  height: auto;
  font-size: 2vw;
  color: #a82024;
}

.buypackbtn {
  position: relative;
  top: 9vw;
  left: 7vw;
  width: 30vw;
  height: 3.5vw;
  font-size: 2vw;
  background-color: #a82024;
  color: #fff;
  text-align: center;
  line-height: 3.5vw;
}
.buypackbtn a {
  color: #fff;
}

.middes {
  position: relative;
  width: 80vw;
  left: 10vw;
  height: auto;
}
.racetype1box {
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 2vw;
  border-radius: 1vw;
  border: 1px solid #ccc;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  box-shadow: 0 14px 21px #4a3aff0f;
  background-color: #0000;
  border: 2px solid #0000;
  border-radius: 10px;
  margin-bottom: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 5px 16px #080f340f;
  margin-bottom: 3vw;;
}
.racetype1box:hover {
  box-shadow: 0 14px 21px #4a3aff0f;
}

.racetype1box.hide {
  display: none;
}
.racetype1image {
  position: relative;
  width: 78vw;
  height: 4vw;
  justify-content: space-between;
  align-items: center;
  display: flex;
}
.racetypearrow {
  background-color: #fff;
  border-radius: 50%;
  flex: none;
  justify-content: center;
  align-items: center;
  width: 50px;
  min-height: 50px;
  display: flex;
  box-shadow: 0 5px 16px #080f340f;
}

.accordion-arrow-wrapper---brix {
  z-index: 200;
  color: #4a3aff;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  padding-bottom: 2px;
  display: flex;
  position: relative;
  transform: rotate(90deg);
}
.accordion-arrow-wrapper---brix-2 {
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
    rotateY(0deg) rotateZ(180deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
  color: rgb(74, 58, 255);
}
.accordion-arrow-wrapper---brix-1 {
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
    rotateY(0deg) rotateZ(90deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
  color: rgb(74, 58, 255);
}

.arrow-line---brix {
  background-color: #4a3aff;
  border-radius: 500px;
  width: 11px;
  min-height: 2px;
  position: absolute;
}

.arrow-line---brix._2---brix {
  right: 7px;
  transform: rotate(-45deg);
}

.arrow-line---brix._1---brix {
  left: 7px;
  transform: rotate(45deg);
}
.racetype1image img {
  width: 100%;
  height: 100%;
}

.racetype1image p{
  font-size: 1.7vw;
  font-weight: bold;
  line-height: 4vw;
  height: 4vw;
  color: #000;
  padding-left: 1vw;
}

.racetype1content {
  position: relative;
  width: 72vw;
  height: 100%;
  background-color: transparent;
  padding: 1vw 4vw 1vw 4vw;
  font-size: 1.2vw;
  margin-top: 2vw;;
}
</style>

<style>
.racetype1content blockquote {
  border-left: 6px solid #a82024; /* 左侧边框 */
  padding-left: 10px; /* 内边距 */
  margin: 16px 0; /* 外边距 */
  background-color: #f9f9f9; /* 背景颜色 */
  height: 3vw;
  line-height: 3vw;
  font-size: 1.2vw;
  font-weight: bold;
}

.racetype1content h3 {
  border-left: 6px solid #a82024; /* 左侧边框 */
  padding-left: 10px; /* 内边距 */
  margin: 16px 0; /* 外边距 */
  background-color: #f9f9f9; /* 背景颜色 */
  height: 3vw;
  line-height: 3vw;
  font-size: 1.2vw;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/racedes.vue